"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.STYLABLE_VALUE_MATCHER = exports.animationPropRegExp = exports.mixinDeclRegExp = exports.STYLABLE_NAMED_MATCHER = exports.stValuesMap = exports.stValues = exports.valueMapping = exports.rootValueMapping = void 0;
/**@deprecated use string instead*/
exports.rootValueMapping = {
    vars: ':vars',
    import: ':import',
    stScope: 'st-scope',
    namespace: 'namespace',
};
/**@deprecated use string instead*/
exports.valueMapping = {
    from: '-st-from',
    named: '-st-named',
    default: '-st-default',
    root: '-st-root',
    states: '-st-states',
    extends: '-st-extends',
    mixin: '-st-mixin',
    partialMixin: '-st-partial-mixin',
    global: '-st-global',
};
/**@deprecated */
exports.stValues = Object.keys(exports.valueMapping).map((key) => exports.valueMapping[key]);
/**@deprecated */
exports.stValuesMap = Object.keys(exports.valueMapping).reduce((acc, key) => {
    acc[exports.valueMapping[key]] = true;
    return acc;
}, {});
/**@deprecated */
exports.STYLABLE_NAMED_MATCHER = new RegExp(`^${exports.valueMapping.named}-(.+)`);
/**@deprecated */
exports.mixinDeclRegExp = new RegExp(`(${exports.valueMapping.mixin})|(${exports.valueMapping.partialMixin})`);
/**@deprecated */
exports.animationPropRegExp = /animation$|animation-name$/;
/**@deprecated */
exports.STYLABLE_VALUE_MATCHER = /^-st-/;
//# sourceMappingURL=value-mapping.js.map